import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Cnotainer, Vertical } from './styled';

interface IProps {
  labelId: string;
}

const Title: React.FC<IProps> = ({ labelId }) => {
  return (
    <Cnotainer>
      <Vertical />
      <FormattedMessage id={labelId} />
    </Cnotainer>
  )
}

export default Title
